<template>
  <!--goDesignworkbench -->
  <li
    @click.stop="goDesign(item)"
    :class="type === 'template' ? 'template-li' : ''"
    @dblclick.stop=""
    class="image-folder--box"
  >
    <div class="image-box">
      <div class="image-d">
        <span
          v-if="item.source === 1"
          class="iconfont icon-Copyright-material"
        ></span>
        <template v-if="type === 'image'">
          <img
            :src="item.url"
            class="folder-img"
            @error="!status ? $parent.imgError(item) : ''"
          />
        </template>
        <template v-else>
          <el-image
            :src="item.cover_url"
            class="folder-img"
            @error="!status ? $parent.imgError(item) : ''"
          />
        </template>
      </div>
      <span class="el-format" v-if="item.format && type === 'image'"
        ><i>{{ item.format ? item.format.toUpperCase() : "" }}</i></span
      >
      <span
        class="iconfont icon-More font-icon-more more-act"
        @click.stop="$parent.moreShow(item)"
        @dblclick.stop=""
      ></span>
      <div
        class="more-box"
        v-if="
          $parent.moreInfo &&
          $parent.moreInfo.id === item.id &&
          $parent.moreStatus
        "
      >
        <p @click.stop="$parent.collect(item)" v-if="collect" @dblclick.stop="">
          收藏
        </p>
        <p
          @click.stop="$parent.renameClick"
          @dblclick.stop=""
          v-if="loginInfo.current_team_role !== 4"
        >
          重命名
        </p>
        <p
          @click.stop="$parent.moveTemp"
          @dblclick.stop=""
          v-if="loginInfo.current_team_role !== 4"
        >
          移动
        </p>
          <p
          @click.stop="$parent.createNewFile(item)"
          @dblclick.stop=""
          v-if="DesignworkbenchType"
        >
          创建副本
        </p>
        <p
          v-if="type !== 'template'"
          @click.stop="download(item)"
          @dblclick.stop=""
        >
          下载
        </p>
        <p
          @click.stop="$parent.removeDialogOpen"
          @dblclick.stop=""
          v-if="isDel"
        >
          删除
        </p>
      </div>
    </div>
    <p class="folder-name text-hidden">{{ item.name }}</p>
    <expireTeamDialog />
  </li>
</template>

<script>
import { Copyright } from "@/config/axios/new_api";
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    status: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "image",
    },
    DesignworkbenchType: {
      // 传递给工作台的值
      type: String,
      default: "",
    },
    DesignworkbenchId: {
      type: String || Number,
      default: "",
    },
    collect: {
      // 收藏按钮展示
      type: Boolean,
      default: false,
    },
  },
  computed: {
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
    isDel(){
        return this.$route.name === 'Space' ? true : this.loginInfo.current_team_role !== 4 && this.item.source !== 1
    }
  },
  methods: {
    goDesign() {
      if (this.status) {
        let type = this.DesignworkbenchType
          ? this.DesignworkbenchType
          : "template";
        let id = this.DesignworkbenchId ? this.DesignworkbenchId : this.item.id;
        console.log(this.item, id, type, "this.item, id, type");
        this.goDesignworkbench(this.item, id, type);
      }
    },
    download(item) {
      let res = this.expireHandle();
      if (res) {
        this.changeHrefTeam().then((status) => {
          if (status) {
            if (item.copyright_id) {
              Copyright.downloadPhoto({
                team_id: this.loginInfo.current_team_id,
                pic_id: item.copyright_id,
              }).then((res) => {
                let link = document.createElement("a");
                link.download = item.name.replace(/\./, "");
                link.href = res.data.url;
                if ("download" in document.createElement("a")) {
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                } else {
                  // 对不支持download进行兼容
                  window.open(res.data.url);
                }
              });
            } else {
              this.staticFunc.downloadImg(
                item.download_url,
                item.name.replace(/\./, "")
              );
            }
          }
        });
      }

      this.$parent.moreStatus = false;
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  width: 150px;
  margin-right: 20px;
  height: 178px;
  margin-bottom: 20px;
  cursor: pointer;
  .el-format {
    position: absolute;
    top: 6px;
    left: 8px;
    background: #000000;
    border-radius: 2px;
    opacity: 0.5;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    width: 26px;
    line-height: 14px;
    i {
      font-size: 12px;
      display: inline-block;
      transform: scale(0.7);
    }
  }
  &:hover {
    .image-d {
      background-color: $hoverColor;
    }
    .more-act {
      display: block;
    }
  }
  .image-box {
    width: 150px;
    height: 150px;
    border-radius: 8px;
    margin-bottom: 8px;
    position: relative;
    .image-d {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      position: relative;
      .iconfont {
        position: absolute;
        top: 8px;
        right: 8px;
        font-size: 12px;
        color: #7966ff;
      }
    }
    img {
      object-fit: scale-down;
      width: 100%;
      height: 100%;
    }
  }
  > p {
    width: 150px;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #3c3c43;
    line-height: 20px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &.template-li {
    @include wh(150px, 178px);
    margin: 0 20px 20px 0;
    cursor: pointer;

    &:hover {
      .image-d {
        background-color: $hoverColor;
      }

      .el-icon-more {
        display: block;
      }
    }

    .image-box {
      width: 150px;
      height: 150px;
      border-radius: 8px;
      margin-bottom: 8px;
      position: relative;

      .image-d {
        @include wh(100%, 100%);
        border-radius: 8px;
      }

      ::v-deep(.el-image) {
        @include wh(150px, 150px);
      }

      ::v-deep(.el-image__inner) {
        object-fit: scale-down;
        @include wh(150px, 150px);
      }
    }

    > p {
      @include wh(150px, 20px);
      font-size: 14px;
      color: #3c3c43;
      line-height: 20px;
      text-align: center;
    }
  }
}
</style>
